import { PermissionsUsersSubTab } from './PermissionsUsersSubTab';
import { PermissionsGroupsSubTab } from './PermissionsGroupsSubTab';
import { PermissionsProjectsSubTab } from './PermissionsProjectsSubTab';

type PermissionsSubtab = 'users' | 'groups' | 'projects';

interface PermissionsTabProps {
  orgId: string;
  activeSubtab: string;
  onSubtabChange: (subtab: PermissionsSubtab) => void;
}

/**
 * Admin-console counterpart of the user app's Admin → Permissions section
 * (Users / Groups / Projects sub-tabs). Only rendered for super_admin /
 * admin_editor — the caller hides the whole tab from admin_viewer.
 */
export function PermissionsTab({ orgId, activeSubtab, onSubtabChange }: PermissionsTabProps) {
  const subtab = (activeSubtab || 'users') as PermissionsSubtab;

  return (
    <>
      <div className="admin-subtabs">
        <button
          className={`tab-button ${subtab === 'users' ? 'active' : ''}`}
          onClick={() => onSubtabChange('users')}
        >
          Users
        </button>
        <button
          className={`tab-button ${subtab === 'groups' ? 'active' : ''}`}
          onClick={() => onSubtabChange('groups')}
        >
          Groups
        </button>
        <button
          className={`tab-button ${subtab === 'projects' ? 'active' : ''}`}
          onClick={() => onSubtabChange('projects')}
        >
          Projects
        </button>
      </div>
      {subtab === 'users' && <PermissionsUsersSubTab orgId={orgId} />}
      {subtab === 'groups' && <PermissionsGroupsSubTab orgId={orgId} />}
      {subtab === 'projects' && <PermissionsProjectsSubTab orgId={orgId} />}
    </>
  );
}
